import { FlexCol, FlexRow, RedirectWithQuery } from '@xylabs/sdk-react'
import { Quadkey } from '@xyo-network/sdk-xyoworld-js'
import React from 'react'
import { Helmet } from 'react-helmet'
import { useParams } from 'react-router-dom'

import { Actions, AuctionCard } from '../../Components'
import { AuctionProvider } from '../../Contexts'
import { AuctionItemToolbar } from '../../Toolbar'
import WorldBasePage from '../WorldBasePage'
import AuctionCardPage from './Card'
import FhrNote from './FhrNote'
import PropertyArea from './PropertyArea'

interface Props {
  paused?: boolean
}

const AuctionPage: React.FC<Props> = (props) => {
  const { paused = true } = props
  const { id } = useParams()
  const quadkeyRequested = Quadkey.fromBase4String(id) ?? Quadkey.root

  if (paused) {
    return <RedirectWithQuery to={`/geotoken/${id}`} />
  }

  return (
    <AuctionProvider quadkey={quadkeyRequested}>
      <WorldBasePage toolbar={<AuctionItemToolbar />} container="xl">
        <Helmet title="Auction Details" />
        <FlexRow alignItems="flex-start" marginY={1}>
          <FlexCol>
            {quadkeyRequested ? <AuctionCard quadkey={quadkeyRequested} size="medium" margin={1} /> : null}
            <Actions quadkey={quadkeyRequested} />
          </FlexCol>
          <PropertyArea margin={0.5} />
        </FlexRow>
        <FhrNote />
      </WorldBasePage>
    </AuctionProvider>
  )
}

export { AuctionCardPage, AuctionPage }
